import { render, staticRenderFns } from "./property-repair.vue?vue&type=template&id=58cbe8f6&scoped=true&"
import script from "./property-repair.vue?vue&type=script&lang=js&"
export * from "./property-repair.vue?vue&type=script&lang=js&"
import style0 from "./property-repair.vue?vue&type=style&index=0&id=58cbe8f6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58cbe8f6",
  null
  
)

export default component.exports